import axios from 'axios';

export async function AddLogCallAPI(logData, token) {
  await axios.post(process.env.REACT_APP_LOGS_API_URL + 'v1/logs', logData, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  });
}